import {License, UPGRADE_PRO} from "../../../gd/const/license";
import ButtonDeprecated from "../../buttons/gd-button/gd-button";
import React from "react";
import {Feature} from "../../../gd/access-control/feature-access/const";
import {LicenseType} from "../../../gd/license/license-proto";
import {
    featureRequiredLicenseName,
    featureRequiredLicenseType
} from "../../../gd/access-control/feature-access/feature-access";
import Button, {ButtonType} from "../../buttons/gd-button/gd-button-ui5-new";

type ScreenUpgradeProps = {
    feature         : Feature
}

// const debug = "ScreenUpgradeSimple"
const debug = false

export default function ScreenUpgradeSimple(props: ScreenUpgradeProps): JSX.Element {


    const feature = props.feature

    debug && console.log(debug, "render() feature=", feature)


    let requiredLicenseName = featureRequiredLicenseName(feature)


    const onUpgradeClick = () => {

        gd.layout.popovers.closeAll()

        gd.tempParamsStorage.set('upgrade-feature', feature)
        gd.goTo('o/'+gd.companyId+'/upgrade');
    };



    return (
        <div className="">

            <div className="flex-row-center-center m-b-20 m-t-20">
                <img src="/app/web/skin/common/svg/gd-logo.svg" className="logo" style={{width: '40px', height: '40px'}} />
            </div>


            <div className="ui5-txt-default m-b-20 m-t-20 m-h-20">This feature requires <strong>{requiredLicenseName} license</strong></div>

            <div className="flex-row-center-center m-b-20">
                <Button label="Upgrade now" type={ButtonType.PRIMARY} onClick={onUpgradeClick} className="btn-confirm"/>
            </div>


        </div>
    )

}